/**
 * Caminho até o valor de um campo de formulário.
 *
 * No registro, todo campo de formulário é guardado como lista de objetos —
 * `Campo: [{ _id: "abc", value: "pingolo" }]` — e é assim que ele chega no
 * gatilho da automação. Quem inserisse só a raiz (`{{ trigger.Campo }}`)
 * recebia o resultado de `Array.prototype.toString` sobre objetos, ou seja
 * `[object Object]`; o caminho útil é o do `value` do item.
 *
 * O sufixo muda com o avaliador do campo: `{{ }}` é Handlebars, que aceita
 * segmento numérico direto (`.0.`), e o modo código é JavaScript, que precisa
 * do índice entre colchetes.
 */

/**
 * Tipos de campo de formulário — os mesmos de `getFieldType`. Saídas de passo
 * (`success`, `id`, `rows`, `value`) e campos de webhook têm outros tipos e
 * ficam de fora, porque não são listas de `{_id, value}`.
 */
const RECORD_FIELD_TYPES = [
    "Text",
    "Numeric",
    "Date",
    "Time",
    "uniqueSelection",
    "multipleSelection",
    "refUniqueSelection",
    "refMultipleSelection",
    "refLookup",
    "formula",
];

export const isRecordFieldSnippet = (snippet) =>
    !!snippet && RECORD_FIELD_TYPES.includes(snippet.fieldtype);

/**
 * Sufixo do primeiro valor do campo, ou string vazia quando a anotação não é
 * um campo de formulário.
 */
export const getRecordValueSuffix = (snippet, isCode = false) => {
    if (!isRecordFieldSnippet(snippet)) return "";
    return isCode ? "[0].value" : ".0.value";
};
